import * as React from "react";
const IconPaperclip = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M32.8 62.3h-.5c-4.6 0-9.6-1.9-12.7-4.8-3.3-3.1-5.1-7.3-5.1-11.6v-31c0-4.3 2.1-8.2 5.8-10.7 3.6-2.5 8.1-3.1 12.3-1.6l.2.1c.5.2 1.1.3 1.7.7 4.6 2.4 7.4 6.7 7.4 11.6v26.5c0 2.7-.9 5.2-2.6 7.2-.3.4-.5.6-.7.7-1.9 1.7-4.1 2.6-6.6 2.6-2.8 0-5.5-1.3-7.3-3.4-1.7-2-2.7-4.6-2.7-7.3V19.2c0-1.2 1-2.3 2.3-2.3s2.3 1 2.3 2.3v22.2c0 1.6.6 3.2 1.6 4.4.9 1.1 2.4 1.8 3.8 1.8 1.3 0 2.4-.5 3.4-1.4l.4-.4c1-1.2 1.6-2.7 1.6-4.3V14.9c0-3.2-1.8-6-5-7.6l-.1-.1c-.2-.1-.4-.2-.8-.3l-.3-.1c-2.9-1-5.9-.6-8.4 1.1C20.3 9.5 19 12 19 14.8v31c0 3 1.4 6.1 3.7 8.3 2.3 2.1 6.2 3.6 9.7 3.6 3.4.1 6.6-1.2 9.1-3.5 2.4-2.3 3.7-5.3 3.6-8.4V21.7c0-1.2 1-2.3 2.3-2.3s2.3 1 2.3 2.3v24.1c.1 4.3-1.7 8.5-5 11.7-3.3 3-7.6 4.8-11.9 4.8" />
  </svg>
);
export default IconPaperclip;
